import { Component } from '@angular/core';
import { FieldComponent } from 'tuain-ng-forms-lib';

@Component({
  selector: 'app-typeahead',
  templateUrl: './app-typeahead.component.html',
})

export class AppTypeAheadComponent extends FieldComponent {

}

